import { Box, Modal } from "@mui/material";
import React, { useState, useEffect } from "react";

export default function RightDrawer({ title, handleClose, children, width = 300 }: { title: string; width?: number; handleClose: () => void; children: JSX.Element }) {
  const [isOpening, setIsOpening] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsOpening(false);
    }, 50)
  }, [])

  return <Modal
    open={true}
    onClose={handleClose}
    aria-labelledby="right-modal"
    sx={{
      display: 'flex',
      justifyContent: 'flex-end',
    }}
  >
    <Box
      sx={{
        width,
        height: "100%",
        bgcolor: "background.paper",
        boxShadow: 24,
        outline: "none",
        position: "relative",
        transform: !isOpening ? "translateX(0%)" : "translateX(100%)",
        transition: "transform 0.2s ease-in-out",
      }}
    > 
      <div className="flex justify-between items-center md:py-15 px-[20px] py-[30px] w-full md:border-b">
        <div className="text-[20px] font-semibold text-center">{title}</div>
        <div onClick={handleClose} className="rista-sprite ic-cross-black"></div>
      </div>
      {children}
    </Box>
  </Modal>
}